// Hindi content for app
const hi = {
  search: 'उत्पादों के लिए खोजें',
  mensClothing: 'पुरुषों के कपड़े',
  womenClothing: 'महिलाओं के वस्त्र',
  jewellery: 'आभूषण',
  electronics: 'इलेक्ट्रानिक्स',
  fifty_percent_off: 'पचास प्रतिशत तक की छूट पाएं',
  holiday_season: 'छुट्टियों के मौसम के लिए',
  thirty_percent_discount_shirts: 'शर्ट पर तीस प्रतिशत तक की छूट पाएं',
  referral_message: 'एक दोस्त को आमंत्रित करें और 5 प्रतिशत तक की छूट पाएं',
  login: 'लॉग इन करें',
  register: 'रजिस्टर करें',
  help_center: 'सहायता केंद्र',
  add_cart: 'कार्ट में डालें',
  select_color: 'रंग चुनो',
  select_size: 'आकार का चयन करें',
  quantity: 'मात्रा',
  free_shipping: 'नि: शुल्क शिपिंग और मुफ्त रिटर्न',
  login_with_google: 'गूगल से लॉग इन करें',
  login_with_fb: 'फेसबुक से लॉग इन करें',
  login_with_your_account: 'अपने अकाउंट में लॉग इन करें',
  access_recommendations: 'अपने ऑर्डर, विशलिस्ट और व्यक्तिगत सुझाव का प्रवेश पावो',
  email_or_username: 'यूजरनाम / फ़ोन नंबर / ईमेल',
  password: 'पासवर्ड',
  password_prompt: 'अपना पासवर्ड डालें',
  username_prompt: 'अपना यूजरनाम / फ़ोन नंबर / ईमेल डालें',
  remember_me: 'मुझे याद राखो',
  forgot_password: 'पासवर्ड भूल गए क्या?',
  create_account: 'नया अकाउंट बनाएं',
  alternate_login: 'या अपने अकाउंट से लॉगिन करें',
  enter_keyword_to_search: 'खोजने के लिए कीवर्ड दर्ज करें',
  no_result_found: 'कोई परिणाम नहीं मिला',
  search_result_for: 'खोज के परिणाम ',
  page_not_found: 'पृष्ठ नहीं मिला',
  settings: 'सेटिंग्स',
  personal_details: 'व्यक्तिगत विवरण',
  your_saved_cards: 'आपके सहेजे गए कार्ड',
  full_name: 'पूरा नाम',
  phone_number: 'फ़ोन नंबर',
  address: 'पता',
  city: 'शहर',
  pin_code: 'पिन कोड',
  state: 'राज्य',
  country: 'देश',
  billing_details: 'बिलिंग विवरण',
  payment_method: 'भुगतान का तरीका',
  card: 'कार्ड',
  cash_on_delivery: 'डिलवरी पर नकदी',
  order_summary: 'खरीद सारांश',
  subTotal: 'उप-योग',
  discount: 'छूट',
  tax: 'कर @ 12.5%',
  delivery_fee: 'वितरण शुल्क',
  total: 'योग',
  place_order: 'खरीदें',
  remove_from_cart: 'कार्ट से निकालें',
};

export default hi;
